import { configureStore } from "@reduxjs/toolkit";
import productReducer from "../features/Product/redux/ProductList.slice";
import productDetailsReducer from "../features/ProductDetail/redux/productDetailsSlice";
import cartReducer from "../features/Cart/redux/cartSlice";
import summaryReducer from "../features/Checkout/redux/summarySlice";
import authReducer from "../features/Auth/hook/authSlice";
import wishlistReducer from "../features/Pages/wishlist/redux/wishlistSlice";

export const store = configureStore({
  reducer: {
   product: productReducer,
   productDetails: productDetailsReducer,
   cart: cartReducer,
   summary: summaryReducer,
   auth: authReducer,
   wishlist: wishlistReducer,
  },
});
export default store;